import React, {Component} from 'react'
import {connect} from "react-redux";
import ComponentHOC from "../hoc/ComponentHOC";
import InternalBanner from "./internal-banner";

class MMpsComponent extends Component {
    render(){
        return (
            <section className="millenials-section mmps-section">
                <div className="container">
                    <InternalBanner banner={this.props.banner}/>
                    <div className="row justify-content-center millenials-list">
                        <div className="col-12 col-md-6 d-flex justify-content-end align-items-center">
                            <h1>
                                {this.props.mmps && this.props.mmps.title}
                            </h1>
                        </div>
                        <div className="col-12 col-md-6">
                            <p dangerouslySetInnerHTML={{ __html: this.props.mmps.description}}></p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default connect(state => state)(ComponentHOC(MMpsComponent))


// WEBPACK FOOTER //
// ./src/components/mmps.js